import React, { useEffect, useState } from "react";
import "./Participants.css";
import ParticipantPerson from "../../../components/DebateRoom/participantPerson/ParticipantPerson";

const Participants = ({ audienceList, coach, activeDebate }) => {
  const [participants, setParticipants] = useState(null);

  useEffect(() => {
    if (!activeDebate?.current) return;
    let result = activeDebate?.current?.teams?.reduce((acc, team) => {
      team.members.forEach((person) => {
        acc.push(person);
      });
      return acc;
    }, []);
    setParticipants(result);
  }, [activeDebate?.current]);

  return (
    <div className="participantsWrapper">
      <div className="participatants_header">
        {participants && (
          <>
            <p>Participants</p>
            {/* <AvatarGroup size='md' max={participants?.length - 1}>
              {
                participants ? participants.map((participant) => (
                  <Avatar key={participant?._id} referrerPolicy="no-referrer" className="avatars" name={participant.firstName} src={participant.avatar} />
                )) : ""
              }
            </AvatarGroup> */}
          </>
        )}
      </div>
      <div className="participation_person_list">
        {participants ? (
          participants?.map((participant) => (
            <ParticipantPerson key={participant?._id} person={participant} />
          ))
        ) : (
          <div className="loading"></div>
        )}
      </div>

      {coach?.length > 0 && (
        <div className="participatants_header">
          <p>Coach</p>
        </div>
      )}
      <div className="participation_person_list">
        {coach?.length > 0 ? (
          coach?.map((ch) => (
            <ParticipantPerson audience={true} key={ch?._id} person={ch} />
          ))
        ) : (
          <div className="loading"></div>
        )}
      </div>
      <div className="participatants_header">
        {audienceList && (
          <>
            <p>Audience</p>
            {/* <AvatarGroup size='md' max={3}>
              {
                audienceList ? audienceList.map((participant) => (
                  <Avatar key={participant?._id} referrerPolicy="no-referrer" className="avatars" name={participant.firstName} src={participant.avatar} />
                )) : ""
              }
            </AvatarGroup> */}
          </>
        )}
      </div>
      <div className="participation_person_list">
        {audienceList ? (
          audienceList?.map((participant) => (
            <ParticipantPerson
              audience={true}
              key={participant._id}
              person={participant}
            />
          ))
        ) : (
          <div className="loading"></div>
        )}
      </div>
    </div>
  );
};

export default Participants;
